import { Locale, type LocalizedString } from "../Locale.js";

export const industrySearchParamLocalized: LocalizedString = {
	[Locale.cs]: "odvetvi",
};
